<template>
	<div class="show">
		<portal to="actions">
			<div class="row">
				<div class="col-12 col-md-6 mb-4 d-flex justify-content-lg-start justify-content-sm-center">
					<button type="button" class="btn btn-primary" v-on:click="$router.back()">
						<i class="fa fa-arrow-left mr-2"></i>
						Back
					</button>
				</div>

				<div class="col-12 col-md-6 mb-4 d-flex justify-content-lg-end justify-content-sm-between">
					<a class="btn btn-primary w-100 w-md-auto" :href="`/api/reports/${report.id}/download`">
						<i class="fa fa-download mr-2"></i>
						Download
					</a>
				</div>
			</div>
		</portal>

		<div
			class="preview"
			v-if="report && report.box_file"
			:style="`height: ${iFrameHeight}px; padding-bottom: 75px;`"
		>
			<vue-box-preview :box-file="report.box_file" width="100%" height="100%" />
		</div>

		<div class="alert alert-danger" role="alert" v-else>
			The preview is not available for this document.
		</div>
	</div>
</template>

<script>
	import Vue from 'vue';

	import VueBoxPreview from '@components/boxPreview';

	import reportsService from '@api/reports';

	export default Vue.extend({
		components: {
			VueBoxPreview
		},
		data() {
			return {
				report: {},
				iFrameHeight: 0,
				loading: {
					report: true
				}
			};
		},
		methods: {
			fetchReport() {
				this.loading.report = true;

				reportsService
					.get(this.$route.params.id)
					.then(response => {
						this.report = response.data;
					})
					.catch(error => {
						window.location.href = `/error/${error.response.status}`;
					});
			},
			setIFrameHeight() {
				const page = document.documentElement.getBoundingClientRect().height;

				this.iFrameHeight = parseInt(page * 0.75);
			}
		},
		mounted() {
			this.fetchReport();

			this.setIFrameHeight();

			window.addEventListener('resize', () => {
				this.setIFrameHeight();
			});
		}
	});
</script>
